import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import smestajImage from '../images/background1.jpg'; // Import slike
import './SearchResults.css';

const SearchResults = () => {
    const location = useLocation();
    const searchResults = location.state?.results || []; // Dobijamo rezultate iz stanja

    return (
        <div className="search-results-page">
            <div className="results-container">
                <h1 className="results-title">Search results:</h1>
                {searchResults.length > 0 ? (
                    <ul className="results-list">
                        {searchResults.map((result, index) => (
                            <li key={index} className="results-item">
                                <div className="result-content">
                                    {/* Link za svaki smeštaj koji vodi na njegovu stranicu */}
                                    <Link to={`/accommodations/${result.slug}`}>
                                        <h2 className="result-name">{result.name}</h2>
                                    </Link>
                                    <p className="result-location">
                                        {result.location}, {result.country}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="no-results">No results found. Try with different accommodation.</p>
                )}
            </div>
        </div>
    );
};

export default SearchResults;
